
import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import { FaGreaterThan } from "react-icons/fa6";

import ServiceBody from "../../ServiceComponents/ServiceBody";

import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";
export default function DigitalMammographyPage() {
    return (
        <>

            <ServiceHeader
                childClass="bmd-page"
                breadcrumb={<>Services <FaGreaterThan size={15} /> Radiology <FaGreaterThan size={15} /> Digital Mammography</>}
                title="Digital Mammography"
            />

            <ServiceBody 
                serviceName = "DigitalMammography"
            />
            <ServiceSection />
            <ConsultSection />
        </>
    )
}